<div id="{{this.propertyId}}Form" [formGroup]="this.formGroup" *ngIf="this.formGroup"> 
  <app-text-field 
    label='Address line 1'       
    propertyName="{{this.prefix}}addressLine1"       
    [formGroup]="this.formGroup"
    [FIELD_SPACING]="20" 
    [regular]="regular" >
  </app-text-field>

  <app-text-field 
    optional
    label='Address line 2'              
    subText="If this address contains 'attention' or 'care of' information, please enter that information in this field as “ATTN:” or “C/O:”."     
    propertyName="{{this.prefix}}addressLine2" 
    [formGroup]="this.formGroup"
    [FIELD_SPACING]="20" 
    [regular]="regular" >
  </app-text-field>

  <app-text-field 
    label='City' 
    propertyName="{{this.prefix}}city"       
    [formGroup]="this.formGroup"
    [FIELD_SPACING]="20" 
    [regular]="regular" >
  </app-text-field>
  <div *ngIf="this.formGroup.get(this.prefix+'country')?.value === 'CA' && this.formGroup.get(this.prefix+'province') != null">
    <div class="row">
        <div class="col-12 col-md-4">
          <div [formGroup]="this.formGroup" class="mt-20">
            <div class="row">
              <div class="col">
                <div class="form-label">Province</div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <select 
                  id="{{this.prefix}}province"
                  name="{{this.prefix}}province"  
                  formControlName="{{this.prefix}}province" 
                  [ngClass]="[regular ? '' : 'input-box']"
                  class="form-control"
                  (change)="this.onProvinceChanged($event)">
                    <option *ngFor="let p of provinces" [value]="p.code">{{p.display}}</option>
                </select>
              </div>
            </div>
          </div>

        </div>
    </div>
  </div>

  <div *ngIf="this.formGroup.get(this.prefix+'country')?.value === 'US' && this.formGroup.get(this.prefix+'state') != null">
    <div class="row">
        <div class="col-12 col-md-4">
          <app-state-dropdown
            propertyName="{{this.prefix}}state"
            [regular]="regular"
            [formGroup]="this.formGroup">
          </app-state-dropdown>
        </div>
    </div>
  </div>


  <div class="row">
    <div class="col-12 col-md-4">
      <app-postal-field 
        label='Postal code or ZIP code' 
        propertyName="{{this.prefix}}postalCode"             
        [formGroup]="this.formGroup" 
        [countryValue]="this.formGroup.get(this.prefix+'country')?.value"
        [regular]="regular" 
        [FIELD_SPACING]="20">
      </app-postal-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-md-4">
      <div class="mt-20">
        <div class="row">
          <div class="col">
            <div class="form-label">
              Country              
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <select
              id="{{this.prefix}}country"
              name="{{this.prefix}}country"
              formControlName="{{this.prefix}}country"
              class="form-control"
              [ngClass]="[regular ? '' : 'input-box']"
              (change)="this.onCountryChanged($event)">
                <option *ngFor="let c of countries" [value]="c.code">{{c.display}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-md-4">
      <div class="mt-20">
        <div class="row">
          <div class="col">
            <div class="form-label">
              Mailing address type              
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <select
              id='{{this.prefix}}addressType'
              name='{{this.prefix}}addressType'
              formControlName='{{this.prefix}}addressType'
              class="form-control"
              [ngClass]="[regular ? '' : 'input-box']"
              (change)="this.onAddressTypeChanged($event)">
                <option *ngFor="let a of addressTypesData" [value]="a.code">{{a.display}}</option>
            </select>
          </div>
        </div>
        <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.prefix}}addressType"></app-validator-message>
      </div>
    </div>
  </div>

</div>